import axios from 'axios';

const csrfElement = document.querySelector('meta[name="csrf-token"]');
export const csrfHeader = { 'X-CSRF-Token': typeof document !== 'undefined' ? (csrfElement && csrfElement.content || '') : '' };

axios.defaults.headers.common = {
  ...csrfHeader,
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};

export default axios;
